import React from 'react';
import { ModalContainer } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import { useAnalyticsOpenScreen } from 'hooks/useAnalyticsOpenScreen';
import { Close, Container, List, Title } from './CallToActionCandidate.styles';
import welbeLogo from 'App/assets/welbe_logo.svg?url';
import labs from 'App/assets/img/labs-money.png';
import { ReactComponent as ChatIcon } from 'App/assets/img/chat.svg';
import Analytics from 'helpers/analytics';

interface ICallToActionCandidateProps {
	onFinish: () => void;
}

export const CallToActionCandidate = ({
	onFinish,
}: ICallToActionCandidateProps): JSX.Element => {
	useAnalyticsOpenScreen({
		context: 'candidate',
		trackName: 'Tour Exams',
	});

	const onSubmit = () => {
		Analytics.track('candidate', 'Tour Exams Support');
		if (window.fcWidget) {
			window.fcWidget.open();
		}
		onFinish();
	};

	return (
		<ModalContainer
			closeOnlyOnTheButton
			visible
			width="530px"
			height="750px"
			borderRadius="6px"
		>
			<Container>
				<img src={welbeLogo} width={'160px'} height={'60px'} alt="welbeLogo" />
				<Title>
					Reduce los costos y tiempo en exámenes de ingreso para tus candidatos
				</Title>
				<img src={labs} width={'160px'} height={'185px'} alt="LabsIcon" />
				<List>
					<li>
						Obtén <b>precios preferenciales</b> en exámenes de laboratorio para
						tus candidatos y colaboradores.
					</li>
					<li>
						<b>Reduce el tiempo</b> de contratación de candidatos.
					</li>
					<li>
						<b>Optimiza tu tiempo:</b> libérate de gestionar proveedores de
						exámenes de laboratorios y reduce tus tareas administrativas
					</li>
				</List>
				<Button onClick={onSubmit}>
					Cotizar exámenes con soporte &nbsp; &nbsp; <ChatIcon />
				</Button>
				<Close onClick={onFinish}>En otro momento</Close>
			</Container>
		</ModalContainer>
	);
};
